export default __webpack_public_path__ + "static/employers-hero-af4bfaeafda555cd2620b923c22030f4.jpeg";